export default __webpack_public_path__ + "static/media/valentino.196c5195.png";